import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";

import { Link, Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks";

import * as styles from "./DescriptionIconAndLink.styles";

interface Props {
  title: string;
  description: string;
  icon: IconProp;
  link: string;
}

const DescriptionIconAndLink: FC<Props> = ({ title, description, icon, link }) => {
  const { tablet } = useBreakpoints();
  const isMobile = tablet.lessThan;

  const renderContent = () => {
    if (!isMobile) {
      return (
        <div css={styles.boxItem}>
          <Link noExternalIcon isUnderLined={false} href={link} data-testid={link}>
            <div css={styles.iconBox}>
              <div css={styles.squareIcon}>
                <span>
                  <FontAwesomeIcon icon={icon} size="1x" />
                </span>
              </div>
            </div>
            <div css={styles.descriptionBox}>
              <Typography type="h5" css={styles.title}>
                <span>{title}</span>
              </Typography>
              <Typography css={styles.description}>{description}</Typography>
            </div>
          </Link>
        </div>
      );
    }

    return (
      <Link noExternalIcon isUnderLined={false} href={link} data-testid={link}>
        <div css={styles.mobileBoxContent}>
          <span css={styles.mobileIcon}>
            <FontAwesomeIcon icon={icon} size="1x" />
          </span>
          <Typography type="body" css={styles.mobileTitle}>
            <span>{title}</span>
          </Typography>
        </div>
      </Link>
    );
  };

  return renderContent();
};

export { DescriptionIconAndLink };
